import { ChakraProvider, theme } from "@chakra-ui/react";
import {
  AnalyticsProvider,
  BadGateway,
  Forbidden,
  GatewayTimeout,
  NetworkError,
  PatientConsolidatedStateProvider,
  ServiceUnavailable,
  Timeout,
  Unauthorized,
  createQueryClient,
  QueryClientProvider,
} from "@metriport/shared-internal";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppStateProvider } from "./components/contexts/app";

import * as Sentry from "@sentry/react";
import OauthError from "./components/error/oauth/Error";
import OauthTimeout from "./components/error/oauth/Timeout";
import AthenaLaunchPage from "./components/ehr/athena/LaunchPage";
import AthenaPatientPage from "./components/ehr/athena/PatientPage";
import CanvasClientIdErrorPage from "./components/ehr/canvas/ClientIdErrorPage";
import CanvasDomainErrorPage from "./components/ehr/canvas/DomainErrorPage";
import CanvasLaunchPage from "./components/ehr/canvas/LaunchPage";
import CanvasPatientPage from "./components/ehr/canvas/PatientPage";
import EClinicalWorksLaunchPage from "./components/ehr/eclinicalworks/LaunchPage";
import EClinicalWorksPatientPage from "./components/ehr/eclinicalworks/PatientPage";
import ElationPatientPage from "./components/ehr/elation/PatientPage";
import HealthiePatientPage from "./components/ehr/healthie/PatientPage";
import SalesforceLaunchPage from "./components/ehr/salesforce/LaunchPage";
import SalesforcePatientPage from "./components/ehr/salesforce/PatientPage";
import PracticeFusionLaunchPage from "./components/ehr/practicefusion/LaunchPage";
import PracticeFusionPatientPage from "./components/ehr/practicefusion/PatientPage";
import BadRequestPage from "./components/error/BadRequest";
import PatientNotFoundPage from "./components/error/PatientNotFound";
import HomePage from "./components/home/HomePage";
// https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/#usage-with-react-router-64-data-api
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
const queryClient = createQueryClient();

export const App = () => {
  return (
    <main>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ChakraProvider theme={theme}>
            <AnalyticsProvider>
              <AppStateProvider>
                <PatientConsolidatedStateProvider>
                  <SentryRoutes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/athena/launch" element={<AthenaLaunchPage />} />
                    <Route path="/athena/app" element={<AthenaPatientPage />} />
                    <Route path="/athena/app/timeout" element={<OauthTimeout />} />
                    <Route path="/athena/app/error" element={<OauthError />} />
                    <Route path="/eclinicalworks/launch" element={<EClinicalWorksLaunchPage />} />
                    <Route path="/eclinicalworks/app" element={<EClinicalWorksPatientPage />} />
                    <Route path="/eclinicalworks/app/timeout" element={<OauthTimeout />} />
                    <Route path="/eclinicalworks/app/error" element={<OauthError />} />
                    <Route path="/canvas/launch" element={<CanvasLaunchPage />} />
                    <Route path="/canvas/app" element={<CanvasPatientPage />} />
                    <Route path="/canvas/client-id-error" element={<CanvasClientIdErrorPage />} />
                    <Route path="/canvas/domain-error" element={<CanvasDomainErrorPage />} />
                    <Route path="/elation/app" element={<ElationPatientPage />} />
                    <Route path="/healthie/app" element={<HealthiePatientPage />} />
                    <Route path="/salesforce/launch" element={<SalesforceLaunchPage />} />
                    <Route path="/salesforce/app" element={<SalesforcePatientPage />} />
                    <Route path="/salesforce/app/timeout" element={<OauthTimeout />} />
                    <Route path="/salesforce/app/error" element={<OauthError />} />
                    <Route path="/practicefusion/launch" element={<PracticeFusionLaunchPage />} />
                    <Route path="/practicefusion/app" element={<PracticeFusionPatientPage />} />
                    <Route path="/practicefusion/app/timeout" element={<OauthTimeout />} />
                    <Route path="/practicefusion/app/error" element={<OauthError />} />
                    <Route path="/bad-gateway" element={<BadGateway />} />
                    <Route path="/forbidden" element={<Forbidden />} />
                    <Route path="/gateway-timeout" element={<GatewayTimeout />} />
                    <Route path="/network-error" element={<NetworkError />} />
                    <Route path="/service-unavailable" element={<ServiceUnavailable />} />
                    <Route path="/timeout" element={<Timeout />} />
                    <Route path="/unauthorized" element={<Unauthorized />} />

                    <Route path="/patient-bad-request" element={<BadRequestPage />} />
                    <Route path="/patient-not-found" element={<PatientNotFoundPage />} />
                  </SentryRoutes>
                </PatientConsolidatedStateProvider>
              </AppStateProvider>
            </AnalyticsProvider>
          </ChakraProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </main>
  );
};
